import { YoutubeSearchedFor } from "@mui/icons-material";
import ActionButton from "../../../UI/BasicLayout/Components/FilterPlusActions/ActionButton";
import { devicesDataId } from "../../../../store/actions/devices/getAllDevices";
import forceRescan, {
  forceRescanId,
} from "../../Actions/forceRescan";
import useUIBp from "../../../../Hooks/useUIBoilerplate";
import { useWorker } from "../../../../Hooks/useWorker";

const UIText = {
  "es-CL": { label: "Forzar escaneo" },
  "en-US": { label: "Force scan" },
};

const Rescan = () => {
  const { auth, dispatch, UI, warehouse, settings } = useUIBp();
  const { working } = useWorker(forceRescanId);
  const selected = UI.selected ?? [];
  const devices = warehouse[devicesDataId];

  const onClick = () => {
    let payload = [];
    for (const mid of selected) {
      const device = devices[mid];
      const payloadItem = {
        user: device.user,
        machine: device.mid,
        token: auth.token,
      };
      payload.push(payloadItem);
    }
    dispatch(
      forceRescan({
        ...auth,
        payload,
        locale: settings.locale,
      })
    );
  };

  return (
    <ActionButton
      {...{
        working,
        disabled: !selected.length,
        onClick,
        UIText,
        icon: <YoutubeSearchedFor />,
        variant: "outlined",
      }}
    />
  );
};

export default Rescan;
